import { useMemo } from 'react'
import { useTranslation } from 'next-i18next'
import { getObjectTitle } from '@/app/object/getObjectTitle'

const useObjectTitle = (object) => {
  const { t } = useTranslation(['object'])

  return useMemo(() => getObjectTitle(object, t), [object, t])
}

export default useObjectTitle
